var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStopOrders = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0625 30C59.0625 13.9453 46.0547 0.9375 30 0.9375C13.9453 0.9375 0.9375 13.9453 0.9375 30C0.9375 46.0547 13.9453 59.0625 30 59.0625C46.0547 59.0625 59.0625 46.0547 59.0625 30ZM6.5625 30C6.5625 17.0508 17.0508 6.5625 30 6.5625C42.9492 6.5625 53.4375 17.0508 53.4375 30C53.4375 42.9492 42.9492 53.4375 30 53.4375C17.0508 53.4375 6.5625 42.9492 6.5625 30ZM41.25 20.625V39.375C41.25 40.4062 40.4062 41.25 39.375 41.25H20.625C19.5938 41.25 18.75 40.4062 18.75 39.375V20.625C18.75 19.5938 19.5938 18.75 20.625 18.75H39.375C40.4062 18.75 41.25 19.5938 41.25 20.625Z",
    fill: "#01035E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStopOrders, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stop-orders.73f7c11d.svg";
export { ForwardRef as ReactComponent };